// extracted by mini-css-extract-plugin
export default {"link":"yO-z","disabled":"zO-z"};